import {Component, OnInit, Input, ɵɵsetComponentScope} from '@angular/core';
import {ApiService} from '../../Services/Api.service';
import {Router} from '@angular/router';
import { exit } from 'process';

@Component({
  selector: 'app-pricing-list',
  templateUrl: './pricing-list.component.html',
  styleUrls: ['./pricing-list.component.scss']
})
export class PricingListComponent implements OnInit {

  @Input() showTrial: any;
  plans = [];
  user: any = {};
  discountCode='';
  discount=0;
  code='';
  discountName='';
  loading=false;
  invalidDiscountCode=false;

  constructor(private router: Router, private apiService: ApiService) {
    // console.log('this is profile!', this.plans, this.showTrial, this);


  }
  showModalDiscount(){
    $("#modal-discount").modal("show");

  }
  checkDiscountCode(){
    let self=this;
    if (this.discountCode=='') return;
    this.loading=true;
    this.apiService.get('checkdiscount?code='+this.discountCode).then((res) => {
      let code=res.data;
      setTimeout(function(){
        if (code){
          self.discount=code.discount_percentage
          self.code=code.code;
          self.discountName=code.name;
          self.invalidDiscountCode=false;

        }else{
          self.invalidDiscountCode=true;
          self.discountCode='';
        }
        self.loading=false;

      },1000);
      
      console.log(res);
    })
    .catch((error) => {
      this.loading = false;
      this.invalidDiscountCode=true;
      this.discountCode='';

    })
  }
  closeModal(){
    $("#modal-discount").modal("hide");

  }
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    console.log('ng on init! pricing', this.user);
    this.get();
  }

  get() {
    this.apiService.get('plans?active=true').then((res) => {
      this.transform(res.data);
      this.plans = res.data;
      this.plans = this.plans.filter(plan => plan.price > 0);
    });
  }

  transform(plans) {

    plans.forEach((plan) => {
      if (this.user !== null && this.user.plan !== null && plan.id === this.user.plan.id) {
        plan.selected = true;
        plan.selecting = false;
      }
    });

  }

  selectPlan(plan) {
    console.log("select plan!", this.user)
    
    if (plan.selected) return;
    if(this.user == null){
      console.log("user is null",null)
      this.router.navigate(['/register']);
   }
    if(this.user.plan.price > 0) {
      console.log('The user already has a paid plan');
      return;}

    if (plan.selected || plan.price === 0) {
        //return;
    }
    if (this.code!=''){
      this.router.navigate(['/logged/profile/payment'], {queryParams: {plan: plan.id,code:this.code}});
    }else{
      this.router.navigate(['/logged/profile/payment'], {queryParams: {plan: plan.id}});

    }

  }
  getClass(plan){
    let classes = '';
      if (!plan.selected&&this.user.plan.price==0) {
        classes = 'colorBack';
      }
      if (!plan.selected&&(this.user.plan.price>0)) {
        classes+=' btnBlock';
      }
      return classes;
  }
}
